import React from "react";

export const permissions = {
  admin: [
    "loop",
    "demosPage",
    "addMentorSlot",
    "classesPage",
    "uploadCsv",
    "AddStudent",
    "createGlimpseEntry",
    "edit_Payment",
    "viewPaymentDetails",
    "bookDemo",
    "pauseClass",
    "initiateRefund",
    "impersonateUser",
    "coursesPage",
    "addCourseOnCoursesPage",
    "editCourseOnCoursesPage",
    "addBatchLoop",
    "EditBatchLoop",
    "autoAddSlot",
    "disableSlots",
    "userPage",
    "promotions",
    "viewSlots",
    "viewStudentList",
    "viewStudentHistory",
    "bootCamp",
    "alchemy",
    "Community",
    "manageStorefront",
    "GlmipsePage",
    "managePromotions",
    "Community",
    "deleteStudentInEditOrder",
    "addCourseInEditOrder",
    "addStudentInEditOrder",
    "deleteCourseInEditOrder",
    "writePermissionsInEditOrder",
    "editClassOnViewSchedule",
    "cancelClassOnViewSchedule",
    "substituteMentorOnViewSchedule",
    "createGlimpseEntryOnViewSchedule",
    "deleteExtraClassOnViewSchedule",
    "reschedulePTMOnViewSchedule",
    "viewConversions",
    "sendOnboardingRequest",
  ],
  mentor: [
    "demosPage",
    "addMentorSlot",
    "GlmipsePage",
    "Community",
    "loop",
    "mentorDashboard",
    "viewSlots",
    "classesPage",
    "viewStudentList",
    "viewStudentHistory",
    "viewConversions",
  ],
  bd_person: [
    "demosPage",
    "viewSlots",
    "classesPage",
    "promotions",
    "Community",
    "AddStudent",
    "viewPaymentDetails",
    "sendOnboardingRequest",
  ],
  cs_person: [
    "loop",
    "demosPage",
    "addBatchLoop",
    "EditBatchLoop",
    "userPage",
    "viewSlots",
    "Community",
    "classesPage",
    "sendOnboardingRequest",
  ],

  Moderator: [
    "loop",
    "coursesPage",
    "demosPage",
    "addBatchLoop",
    "EditBatchLoop",
    "classesPage",
    "viewSlots",
    "impersonateUser",
    "deleteStudentInEditOrder",
    "addCourseInEditOrder",
    "addStudentInEditOrder",
    "deleteCourseInEditOrder",
    "writePermissionsInEditOrder",
    "editClassOnViewSchedule",
    "cancelClassOnViewSchedule",
    "substituteMentorOnViewSchedule",
    "deleteExtraClassOnViewSchedule",
    "reschedulePTMOnViewSchedule",
    "userPage",
    "sendOnboardingRequest",
  ],

  bd_manager: [
    "demosPage",
    "classesPage",
    "coursesPage",
    "viewSlots",
    "Community",
    "AddStudent",
    "viewPaymentDetails",
    "sendOnboardingRequest",
  ],
  affiliate_partner: ["demosPage", "affiliateDemos"],
};
